import { ContactListItem, Modal, TinyButton, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { PlusIcon } from '@phosphor-icons/react'
import { Contact } from 'ComponentLibrary/src/common/users'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import {
    ContactForm,
    ContactFormInfoBox,
    type ContactFormCopy,
    DEFAULT_CONTACT_FORM_COPY,
} from 'ComponentLibrary/src/molecules/ContactList/ContactForm'
import { type ContactListItemCopy } from 'ComponentLibrary/src/molecules/ContactList/ContactListItem'
import { type UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'

type ContactListProps = {
    contacts: Contact[]
    isAddContactFormOpen: boolean
    setIsAddContactFormOpen: (isOpen: boolean) => void
    addContact: (contact: Contact) => void
    updateContact: (index: number, contact: Contact) => void
    deleteContact: (index: number) => void
    emptyStateText?: string
    copy?: Partial<ContactListCopy>
    userLinkCopy?: Partial<UserLinkCopy>
}

export type ContactListCopy = {
    addButtonLabel: string
    addModalTitle: string
    item: ContactListItemCopy
    form: ContactFormCopy
}

const DEFAULT_CONTACT_LIST_COPY: ContactListCopy = {
    addButtonLabel: 'Kontakt hinzufügen',
    addModalTitle: 'Kontakt hinzufügen',
    item: {
        edit: 'Bearbeiten',
        delete: 'Löschen',
        editModalTitle: 'Ansprechpartner bearbeiten',
        form: DEFAULT_CONTACT_FORM_COPY,
    },
    form: DEFAULT_CONTACT_FORM_COPY,
}

export const ContactList = ({
    contacts,
    isAddContactFormOpen,
    setIsAddContactFormOpen,
    addContact,
    updateContact,
    deleteContact,
    emptyStateText,
    copy,
    userLinkCopy,
}: ContactListProps) => {
    const resolvedCopy = { ...DEFAULT_CONTACT_LIST_COPY, ...copy }
    const formCopy = { ...DEFAULT_CONTACT_FORM_COPY, ...copy?.form }
    const itemCopy = { ...DEFAULT_CONTACT_LIST_COPY.item, ...copy?.item, form: formCopy }

    return (
        <Stack direction="column" marginTop="0px">
            {!isAddContactFormOpen && contacts.length === 0 && (
                <Stack direction="column" gap={tokens.SizingSpacing200}>
                    {emptyStateText && (
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {emptyStateText}
                        </Typography>
                    )}
                    <TinyButton onClick={() => setIsAddContactFormOpen(true)} label={resolvedCopy.addButtonLabel} leftIcon={<PlusIcon />} />
                </Stack>
            )}
            {isAddContactFormOpen && (
                <Modal
                    isOpen={isAddContactFormOpen}
                    showCloseIcon
                    onClose={() => setIsAddContactFormOpen(false)}
                    title={resolvedCopy.addModalTitle}
                >
                    <Stack direction="column" gap={tokens.SizingSpacing300}>
                        <ContactFormInfoBox text={formCopy.infoBox} />
                        <ContactForm setFormIsOpen={setIsAddContactFormOpen} onSubmitCallback={addContact} copy={formCopy} />
                    </Stack>
                </Modal>
            )}
            <Stack direction="column" gap={tokens.SizingSpacing200}>
                {contacts.map((contact, index) => (
                    <ContactListItem
                        key={index}
                        contact={contact}
                        updateContact={(contact: Contact) => updateContact(index, contact)}
                        deleteContact={() => deleteContact(index)}
                        copy={itemCopy}
                        userLinkCopy={userLinkCopy}
                    />
                ))}
            </Stack>
        </Stack>
    )
}
